import type { FieldFormatter, FieldValidator } from '@lucidtech/las-sdk-browser';
import { memo } from 'react';

import { Badge, Text } from '@/components/core';
import { FormatterLogo, ValidatorLogo } from '@/components/logos';
import { BetaBadge } from '@/components/ui';
import { FORMATTER_MAPPING_FUNCTION_ID } from '@/constants';

export type FormatterValidatorHeaderProps = {
  formatter?: FieldFormatter;
  validator?: FieldValidator;
};

const IFormatterValidatorHeader = ({ formatter, validator }: FormatterValidatorHeaderProps) => {
  return (
    <div className="flex items-center gap-4">
      {formatter ? (
        <FormatterLogo size="xl" formatter={formatter} />
      ) : validator ? (
        <ValidatorLogo size="xl" validator={validator} />
      ) : null}
      <div className="flex flex-col">
        <div className="gap-sm flex items-center">
          <Badge
            className="!rounded-sm !px-1"
            variant="default"
            label={formatter ? 'formatter' : validator ? 'validator' : 'unknown'}
          />
        </div>
        <div className="gap-sm flex items-center">
          <Text>{formatter ? formatter.name : validator ? validator.name : null}</Text>
          {formatter?.functionId === FORMATTER_MAPPING_FUNCTION_ID ? <BetaBadge /> : null}
        </div>
      </div>
    </div>
  );
};

export const FormatterValidatorHeader = memo(IFormatterValidatorHeader) as typeof IFormatterValidatorHeader;
